import { fnsFormatDate } from "@/utils/date-fns";

export const dateFilter = (
  value: string,
  format: string = "yyy-MM-dd HH:mm:ss"
): string => {
  if (!value) {
    return "";
  }

  if (value.includes(" ")) {
    const split = value.split(" ")[0].split("-");
    return `${split[1]}/${split[2]}/${split[0]}`;
  }

  if (value.includes("T")) {
    return fnsFormatDate(new Date(value), format);
  }

  return value;
};
